import React from 'react';
import styles from './UploadProgress.module.css';

const UploadProgress = ({ progress = 0 }) => {
  // Calculate the stroke-dashoffset for the circular progress
  const radius = 60;
  const circumference = 2 * Math.PI * radius;
  const offset = circumference - (progress / 100) * circumference;

  return (
    <div className={styles.container}>
      <div className={styles['upload-icon-container']}>
        {/* Background circle */}
        <div className={styles['background-circle']}></div>
        
        {/* Circular progress indicator */}
        <svg className={styles['progress-ring']} viewBox="0 0 140 140">
          <circle
            className={styles['progress-ring-background']}
            cx="70"
            cy="70"
            r={radius}
          />
          <circle
            className={styles['progress-ring-progress']}
            cx="70"
            cy="70"
            r={radius}
            strokeDasharray={circumference}
            strokeDashoffset={offset}
          />
        </svg>
        
        {/* Camera icon */}
        <div className={styles['camera-icon']}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
            <polygon points="23 7 16 12 23 17 23 7"/>
            <rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>
          </svg>
        </div>
      </div>
    </div>
  );
};

export default UploadProgress;
